/* Aquaflow Irrigation — Theme JS */

/* ── Helpers ──────────────────────────────────────────────────────────────── */

function formatMoney(cents) {
  return '£' + (Number(cents) / 100).toFixed(2);
}

/* ── Variant price switcher ───────────────────────────────────────────────────
 *
 * Data is stored in <input class="aq-variant-row"> elements inside the product
 * form. Each input holds one variant's id, price, compare-at, availability,
 * sku, and option values as data-* attributes.
 *
 * This runs as an external deferred script so it is NEVER blocked by any
 * Content Security Policy that restricts inline scripts or event handlers.
 * ───────────────────────────────────────────────────────────────────────── */

function initVariantSwitcher() {
  var rows = document.querySelectorAll('input.aq-variant-row');
  if (!rows.length) return;  /* not a product page with variants data */

  /* Build a plain array of variant objects from the data attributes */
  var variants = [];
  for (var r = 0; r < rows.length; r++) {
    var d = rows[r].dataset;
    variants.push({
      id:              parseInt(d.id, 10),
      price:           parseInt(d.price, 10),
      compare_at_price: parseInt(d.compare, 10) || 0,
      available:       d.available === 'true',
      sku:             d.sku || '',
      opt1:            d.opt1 || '',
      opt2:            d.opt2 || '',
      opt3:            d.opt3 || ''
    });
  }

  /* Find option selects (id="option-1", "option-2", …) */
  var selects = [];
  for (var i = 1; i <= 3; i++) {
    var sel = document.getElementById('option-' + i);
    if (sel) selects.push(sel);
  }
  if (!selects.length) return;  /* no dropdowns — single-variant product */

  /* ── Core: find the variant that matches the current dropdown values ── */
  function findVariant() {
    var chosen = selects.map(function(s) { return s.value; });
    for (var v = 0; v < variants.length; v++) {
      var vrt = variants[v];
      var opts = [vrt.opt1, vrt.opt2, vrt.opt3];
      var match = true;
      for (var o = 0; o < chosen.length; o++) {
        if (String(opts[o]) !== String(chosen[o])) { match = false; break; }
      }
      if (match) return vrt;
    }
    return null;
  }

  /* ── Apply a matched variant to every relevant element on the page ── */
  function applyVariant(vrt) {
    if (!vrt) return;

    var idInput = document.getElementById('variant-id-input');
    if (idInput) idInput.value = vrt.id;

    var priceEl = document.getElementById('product-price');
    if (priceEl) priceEl.textContent = formatMoney(vrt.price);

    var onSale = vrt.compare_at_price && vrt.compare_at_price > vrt.price;
    var cmpEl  = document.getElementById('product-compare-price');
    var savEl  = document.getElementById('product-savings');
    if (cmpEl) { cmpEl.style.display = onSale ? '' : 'none'; if (onSale) cmpEl.textContent = formatMoney(vrt.compare_at_price); }
    if (savEl) { savEl.style.display = onSale ? '' : 'none'; if (onSale) savEl.textContent = 'Save ' + formatMoney(vrt.compare_at_price - vrt.price); }

    var dot = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="6"/></svg> ';
    var stockEl = document.getElementById('product-stock');
    if (stockEl) {
      stockEl.innerHTML   = dot + (vrt.available ? 'In stock' : 'Out of stock');
      stockEl.style.color = vrt.available ? 'var(--color-accent)' : 'var(--color-danger)';
    }

    var btn = document.getElementById('add-to-cart-btn');
    if (btn) {
      btn.disabled    = !vrt.available;
      btn.textContent = vrt.available ? 'Add to cart' : 'Sold out';
      btn.style.opacity = vrt.available ? '' : '0.5';
    }

    var skuWrap = document.getElementById('product-sku');
    var skuVal  = document.getElementById('product-sku-value');
    if (skuWrap) {
      if (vrt.sku) { if (skuVal) skuVal.textContent = vrt.sku; skuWrap.style.display = ''; }
      else skuWrap.style.display = 'none';
    }
  }

  /* Attach change listener to every option select */
  selects.forEach(function(sel) {
    sel.addEventListener('change', function() {
      applyVariant(findVariant());
    });
  });
}

/* ── Mobile menu ──────────────────────────────────────────────────────────── */

function initMobileMenu() {
  var toggle = document.querySelector('.mobile-toggle');
  var nav    = document.querySelector('.header-nav');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', function() {
    nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', nav.classList.contains('is-open'));
  });
}

/* ── Search bar ───────────────────────────────────────────────────────────── */

function initSearch() {
  var searchToggle = document.getElementById('search-toggle');
  var searchBar    = document.getElementById('search-bar');
  var searchClose  = document.getElementById('search-close');
  if (!searchToggle || !searchBar) return;
  searchToggle.addEventListener('click', function() {
    searchBar.classList.toggle('is-open');
    if (searchBar.classList.contains('is-open')) {
      var input = searchBar.querySelector('input[name="q"]');
      if (input) input.focus();
    }
  });
  if (searchClose) {
    searchClose.addEventListener('click', function() { searchBar.classList.remove('is-open'); });
  }
}

/* ── Quantity selectors ───────────────────────────────────────────────────── */

function initQuantitySelectors() {
  document.querySelectorAll('.quantity-selector').forEach(function(el) {
    var minus = el.querySelector('[data-action="minus"]');
    var plus  = el.querySelector('[data-action="plus"]');
    var input = el.querySelector('input');
    if (!minus || !plus || !input) return;
    minus.addEventListener('click', function() {
      var val = parseInt(input.value) || 1;
      if (val > 1) { input.value = val - 1; }
    });
    plus.addEventListener('click', function() {
      var val = parseInt(input.value) || 1;
      input.value = val + 1;
    });
  });
}

/* ── Scroll animations ────────────────────────────────────────────────────── */

function initScrollAnimations() {
  if (!('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) { entry.target.classList.add('animate-in'); observer.unobserve(entry.target); }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.service-card, .collection-card, .testimonial-card, .product-card').forEach(function(el) {
    observer.observe(el);
  });
}

/* ── Sticky header ────────────────────────────────────────────────────────── */

function initStickyHeader() {
  var header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', function() {
    header.style.boxShadow = window.scrollY > 10 ? '0 2px 12px rgba(0,0,0,0.06)' : 'none';
  }, { passive: true });
}

/* ── Boot ─────────────────────────────────────────────────────────────────── */

function initAll() {
  try { initVariantSwitcher(); }   catch(e) { console.warn('variant switcher:', e); }
  try { initMobileMenu(); }        catch(e) { console.warn('mobile menu:', e); }
  try { initSearch(); }            catch(e) { console.warn('search:', e); }
  try { initQuantitySelectors(); } catch(e) { console.warn('quantity:', e); }
  try { initScrollAnimations(); }  catch(e) { console.warn('animations:', e); }
  try { initStickyHeader(); }      catch(e) { console.warn('sticky header:', e); }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

window.addEventListener('pageshow', function(event) {
  if (event.persisted) { initAll(); }
});
